import { createAction } from 'shared/utils';

export const PAYMENT_INIT = createAction('PAYMENT_PAGE_INIT');
export const PAYMENT_BILL_GETS = createAction('PAYMENT_PAGE_BILL_GETS');
export const PAYMENT_BILL_SUM_PAYMENT_GETS = createAction('PAYMENT_PAGE_BILL_SUM_PAYMENT_GETS');
export const PAYMENT_RECEIPT_CREATE = createAction('PAYMENT_PAGE_RECEIPT_CREATE');
export const PAYMENT_UNIT_GETS = createAction('PAYMENT_UNIT_GETS');
